import React from "react";
import { formatDate } from "../../utils/units";
import KafkaLogs from "../KafkaLogs";

const SSLManagementCard = ({
  project,
  sslStatus,
  sslLoading,
  sslError,
  setSslPopup,
  checkSSLStatus
}) => {
  return (
    <div className="details-card">
      <div className="details-card-header">
        <span>
          <i className="bi bi-shield-lock me-2"></i> SSL Certificate Management
        </span>
      </div>
      <div className="details-card-body">
        {sslLoading ? (
          <div className="d-flex justify-content-center align-items-center py-4">
            <div className="spinner-border text-primary" role="status"></div>
            <span className="ms-2">Processing SSL certificate...</span>
          </div>
        ) : (
          <>
            <div className="ssl-status-card mb-4">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <h6 className="mb-2 text-muted">Certificate Status</h6>
                  {sslStatus ? (
                    <div className="d-flex align-items-center gap-2">
                      <span
                        className={`status-dot ${sslStatus.installed ? "live" : "warning"}`}
                      ></span>
                      <span
                        className={
                          sslStatus.installed
                            ? "text-success fw-bold"
                            : "text-warning fw-bold"
                        }
                      >
                        {sslStatus.installed ? "Installed" : "Not Installed"}
                      </span>
                    </div>
                  ) : (
                    <span className="text-muted">Checking...</span>
                  )}
                </div>
                {sslStatus?.installed && sslStatus?.expiryDate && (
                  <div className="col-md-6 mt-3 mt-md-0">
                    <h6 className="mb-2 text-muted">Expiry Date</h6>
                    <div className="fw-medium">
                      {formatDate(sslStatus.expiryDate, "day-shortMonth-year")}
                    </div>
                    <div
                      className={`fs-7 ${
                        sslStatus.isExpired
                          ? "text-danger"
                          : sslStatus.needsRenewal
                          ? "text-warning"
                          : "text-success"
                      }`}
                    >
                      {sslStatus.isExpired
                        ? "⚠️ Expired"
                        : sslStatus.needsRenewal
                        ? `⚠️ Expires in ${sslStatus.daysUntilExpiry} days`
                        : `✓ Valid for ${sslStatus.daysUntilExpiry} days`}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {sslError && (
              <div className="alert alert-danger mb-3">
                <strong>Error:</strong> {sslError}
              </div>
            )}

            <div className="d-flex gap-2 flex-wrap mb-4">
              {sslStatus?.installed ? (
                <>
                  <button
                    onClick={() => setSslPopup("renew")}
                    className="btn btn-warning text-white"
                    disabled={sslLoading}
                  >
                    <i className="bi bi-arrow-repeat me-1"></i> Renew Certificate
                  </button>
                  <button
                    onClick={() => setSslPopup("remove")}
                    className="btn btn-danger"
                    disabled={sslLoading}
                  >
                    <i className="bi bi-trash me-1"></i> Remove Certificate
                  </button>
                </>
              ) : (
                <button
                  onClick={() => setSslPopup("install")}
                  className="btn btn-success"
                  disabled={sslLoading}
                >
                  <i className="bi bi-lock-fill me-1"></i> Install SSL Certificate
                </button>
              )}
              <button
                onClick={checkSSLStatus}
                className="btn btn-outline-secondary"
                disabled={sslLoading}
              >
                <i className="bi bi-arrow-clockwise me-1"></i> Refresh Status
              </button>
            </div>
          </>
        )}
        <div className="accordion" id="sslLogsAccordion">
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingSslLogs">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseSslLogs"
              >
                <i className="bi bi-file-earmark-text me-2"></i> SSL Logs
              </button>
            </h2>
            <div
              id="collapseSslLogs"
              className="accordion-collapse collapse"
              data-bs-parent="#sslLogsAccordion"
            >
              <div className="accordion-body">
                <KafkaLogs topic="sslcertification" domain={project.domain} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SSLManagementCard;
